(() => {
  if (window.ameliaDemoRatingsInitialized) return;
  window.ameliaDemoRatingsInitialized = true;
  
  // Força 'preview' a ser sempre true para exibir sempre o rating de demonstração
  const preview = true;
  
  const apply = scope => {
    const groups = [...(scope.querySelectorAll?.('[data-amelia-rating-group]') || [])];
    if (scope.matches?.('[data-amelia-rating-group]')) groups.push(scope);
    for (const group of groups) {
      const sample = group.querySelector('[data-amelia-rating="preview"]');
      const real = group.querySelector('[data-amelia-rating="real"]');
      if (sample) sample.hidden = !preview;
      if (real) real.hidden = preview && Boolean(sample);
    }
    
    // Procura e exibe elementos com [data-amelia-preview-only]
    const samples = [...(scope.querySelectorAll?.('[data-amelia-preview-only]') || [])];
    if (scope.matches?.('[data-amelia-preview-only]')) samples.push(scope);
    samples.forEach(el => { el.hidden = !preview; });
  };

  apply(document);
  
  new MutationObserver(records => {
    for (const record of records) for (const node of record.addedNodes) if (node.nodeType === 1) apply(node);
  }).observe(document.documentElement, {childList:true,subtree:true});
})();